/***
 *
 *   PASSWORD
 *   Update the users password
 *
 **********/

import { Fragment, useState } from 'react';
import { AccountNav, Animate, Card, Form, Message } from 'components/lib';
import { changePassword } from '../../lib/auth-client';

interface PasswordProps {
  className?: string;
}

export function Password(props: PasswordProps) {
  const [done, setDone] = useState(false);

  return (
    <Fragment>
      <AccountNav />
      <Animate>
        <Card
          title="Update Your Password"
          restrictWidth
          center
          className={props.className}
          extraClass="form-container"
          isStat={true}
        >
          {!done ? (
            <Form
              customSubmit={async (data) => {
                const { oldpassword, newpassword } = data as { oldpassword: string; newpassword: string };
                await changePassword(oldpassword, newpassword);

                return {
                  message: 'Password updated',
                };
              }}
              buttonText="Save Password"
              buttonVariant="outlined"
              disableModalYesClass
              fullWidthButton={false}
              alignRight
              data={{
                oldpassword: {
                  label: 'Old Password',
                  type: 'password',
                  required: true,
                },
                newpassword: {
                  label: 'Create New Password',
                  type: 'password',
                  required: true,
                  complexPassword: true,
                },
              }}
              callback={() => {
                setDone(true);
              }}
            />
          ) : (
            <Message title="Password Saved" type="success" text="Your new password has been saved successfully." />
          )}
        </Card>
      </Animate>
    </Fragment>
  );
}
